import React, { Component } from "react";

import { connect } from "react-redux";

class SideBar extends Component {
  state = {
    cor_setada: "",
  };

  componentDidMount() {
    document.documentElement.style.setProperty("--cor-principal", this.props.corPrincipal);
    document.documentElement.style.setProperty(
      "--cor-principal-hover",
      this.props.corPrincipal
    );
  }

  componentWillReceiveProps(nextProps) {
 
 
    if (nextProps.corPrincipal !== this.state.cor_setada) {
      this.setState({
        cor_setada: nextProps.corPrincipal,
      });
      document.documentElement.style.setProperty(
        "--cor-principal",
        nextProps.corPrincipal
      );
      document.documentElement.style.setProperty(
        "--cor-principal-hover",
        nextProps.corPrincipal + "61"
      );
    }
  }

  render() {
    const { props } = this;

    return (
      <aside
        className="main-sidebar"
        style={props.esconderSidebar ? { paddingTop: "95px" } : {}}
      >
        <section className="sidebar">
          <ul className="sidebar-menu">
            {/* Items do menu */}
            {props.children}
          </ul>
        </section>
      </aside>
    );
  }
}

export default connect(
  (state) => ({
    empresa: state.empresa,
  }),
  (dispatch) => ({
    dispatch,
  })
)(SideBar);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/sidebar/SideBar.jsx